import {
  validationObject,
  validateName,
  validatePhoneNumber,
} from 'utils/validations';
import { ALL_ROLES_OPTIONS, ROLES } from 'utils/constants/roles';

export const initialState = {
  firstName: '',
  lastName: '',
  country: '',
  phone: '',
  image: '',
};

export const validationSchema = validationObject({
  firstName: validateName(30),
  lastName: validateName(30),
  phone: validatePhoneNumber(),
});

export const generalSection = (countries, role) => [
  {
    field: 'employeeId',
    label: 'Employee ID',
    type: 'text',
    required: role === ROLES.GUARD.id,
    size: 'half',
    placeholder: 'Enter employee id. E.g. EMP-0001',
    disabled: true,
  },
  {
    field: 'role',
    type: 'select',
    required: true,
    size: 'half',
    options: ALL_ROLES_OPTIONS,
    disabled: true,
  },
  {
    field: 'email',
    type: 'text',
    required: true,
    size: 'half',
    disabled: true,
  },
  {
    field: 'firstName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter first name',
  },
  {
    field: 'lastName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter last name',
  },
  {
    field: 'phone',
    type: 'phone',
    required: true,
    size: 'full',
    secondaryOptions: countries,
  },
];
